import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromAuth from './+state/auth/auth.reducer';
import { AuthEffects } from './+state/auth/auth.effects';
import { AuthFacade } from './+state/auth/auth.facade';
import * as fromShared from './+state/shared/shared.reducer';
import { SharedEffects } from './+state/shared/shared.effects';
import { SharedFacade } from './+state/shared/shared.facade';
import * as fromUserDetails from './+state/user-details/user-details.reducer';
import { UserDetailsEffects } from './+state/user-details/user-details.effects';
import { UserDetailsFacade } from './+state/user-details/user-details.facade';
import * as fromDashboard from './+state/dashboard/dashboard.reducer';
import { DashboardEffects } from './+state/dashboard/dashboard.effects';
import { DashboardFacade } from './+state/dashboard/dashboard.facade';
import * as fromCustom from './+state/custom/custom.reducer';
import { CustomEffects } from './+state/custom/custom.effects';
import { CustomFacade } from './+state/custom/custom.facade';
import * as fromMyOrganization from './+state/my-organization/my-organization.reducer';
import { MyOrganizationEffects } from './+state/my-organization/my-organization.effects';
import { MyOrganizationFacade } from './+state/my-organization/my-organization.facade';
import * as fromAdministrator from './+state/administrator/administrator.reducer';
import { AdministratorEffects } from './+state/administrator/administrator.effects';
import { AdministratorFacade } from './+state/administrator/administrator.facade';
import * as fromProjects from './+state/projects/projects.reducer';
import { ProjectsEffects } from './+state/projects/projects.effects';
import { ProjectsFacade } from './+state/projects/projects.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromAuth.AUTH_FEATURE_KEY, fromAuth.authReducer),
    EffectsModule.forFeature([AuthEffects]),
    StoreModule.forFeature(fromShared.SHARED_FEATURE_KEY, fromShared.sharedReducer),
    EffectsModule.forFeature([SharedEffects]),
    StoreModule.forFeature(
      fromUserDetails.USER_DETAILS_FEATURE_KEY,
      fromUserDetails.userDetailsReducer
    ),
    EffectsModule.forFeature([UserDetailsEffects]),
    StoreModule.forFeature(fromDashboard.DASHBOARD_FEATURE_KEY, fromDashboard.dashboardReducer),
    EffectsModule.forFeature([DashboardEffects]),
    StoreModule.forFeature(fromCustom.CUSTOM_FEATURE_KEY, fromCustom.customReducer),
    EffectsModule.forFeature([CustomEffects]),
    StoreModule.forFeature(
      fromMyOrganization.MY_ORGANIZATION_FEATURE_KEY,
      fromMyOrganization.myOrganizationReducer
    ),
    EffectsModule.forFeature([MyOrganizationEffects]),
    StoreModule.forFeature(
      fromAdministrator.ADMINISTRATOR_FEATURE_KEY,
      fromAdministrator.administratorReducer
    ),
    EffectsModule.forFeature([AdministratorEffects]),
    StoreModule.forFeature(fromProjects.PROJECTS_FEATURE_KEY, fromProjects.projectsReducer),
    EffectsModule.forFeature([ProjectsEffects]),
  ],
  providers: [
    AuthFacade,
    SharedFacade,
    UserDetailsFacade,
    DashboardFacade,
    CustomFacade,
    MyOrganizationFacade,
    AdministratorFacade,
    ProjectsFacade,
    DecimalPipe,
  ],
})
export class DataModule {}
